import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { firstValueFrom } from 'rxjs';
import { fileToBase64, getErrorMessage, markFormGroupTouched } from '../../../general/utils';
import { ConhecimentoTransporteService } from '../../../services/conhecimento-transporte.service';
import { MessageService } from '../../../services/message.service';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';

@Component({
  selector: 'app-cte-importar-xml-cte',
  templateUrl: './cte-importar-xml-cte.component.html',
  styleUrls: ['./cte-importar-xml-cte.component.css']
})
export class CteImportarXmlCteComponent extends ModalCadastroComponent implements OnInit {
  @ViewChild('modalCadastro', { static: true }) modalCadastro;

  constructor(
    private messageService: MessageService,
    private conhecimentoTransporteService: ConhecimentoTransporteService,
  ) {
    super();
  }

  maximoArquivos = 100;
  loading = {
    importarXmls: false,
  };
  passo: 'IMPORTAR' | 'ERROS' = 'IMPORTAR';
  chavesCteReferenciados = [];
  remetenteCnpj = null;
  importacao = null;

  public form = new FormGroup({
    files: new FormControl(null, [ FileUploadValidators.filesLimit(this.maximoArquivos), FileUploadValidators.accept(['.xml']) ]),
  });

  ngOnInit() {
    this.chavesCteReferenciados = this.prop.chavesCteReferenciados;
    this.remetenteCnpj = this.prop.remetenteCnpj;
  }

  show() {
    this.modalCadastro.show();
  }

  async importarXmls() {
    markFormGroupTouched(this.form);
    const arquivos = this.form.get('files');
    if (this.hasErrors(arquivos)) {
      return;
    }

    try {
      this.loading.importarXmls = true;
      const req = {
        chavesCteReferenciados: this.chavesCteReferenciados,
        remetenteCnpj: this.remetenteCnpj,
        arquivos: [],
      };

      for (const file of arquivos.value) {
        const base64 = await fileToBase64(file);
        req.arquivos.push({
          nome: file.name,
          base64: base64,
        });
      }

      this.importacao = await firstValueFrom(this.conhecimentoTransporteService.importarXmlCte(req));
      if (this.importacao?.erros.length === 0) {
        this.closed.emit(this.importacao);
      } else {
        this.loading.importarXmls = false;
        this.passo = 'ERROS';
      }
    } catch (err) {
      this.loading.importarXmls = false;
      if (getErrorMessage(err).includes('Request body too large.')) {
        this.messageService.error('Tamanho máximo de 20MB excedido.', 5000, '', false);
      } else {
        this.messageService.error(getErrorMessage(err), 8000);
      }
    }
  }

  hasErrors(arquivos): boolean {
    if (!arquivos.value) {
      this.messageService.error('Selecione pelo menos 1 arquivo!', 5000);
      return true;
    }

    if (arquivos.errors) {
      if (arquivos.errors.fileTypes) {
        this.messageService.error('Tipo de arquivo inválido. São aceitos somente arquivos .XML', 5000, '', false);
      } else if (arquivos.errors.filesLimit) {
        this.messageService.error('O máximo de arquivos é ' + this.maximoArquivos + '!', 5000, '', false);
      }

      return true;
    }

    const tamanhoTotal = arquivos.value.map(x => x.size).reduce((acc, x) => acc + x, 0);
    if (tamanhoTotal > 20*1024*1024) {
      this.messageService.error('Tamanho máximo de 20MB excedido.', 5000, '', false);
      return true;
    }

    return false;
  }

  arquivosImportados() {
    const quantidade = this.form.get('files').value === null ? 0 : this.form.get('files').value.length;
    return quantidade + ' / ' + this.maximoArquivos;
  }

  continuar() {
    this.closed.emit(this.importacao);
  }

  voltar() {
    this.passo = 'IMPORTAR';
  }
}
